export default __webpack_public_path__ + "static/media/warning.42f37ed0.svg";